export const MARKER_BLUE = '#4A89F3';
export const MARKER_RED = '#E74C3C';

export const MARKER_SVG_PATH =
  'M192 0C86 0 0 86 0 192c0 142 192 320 192 320s192-178 192-320C384 86 298 0 192 0zm0 272a80 80 0 1 1 0-160 80 80 0 0 1 0 160z';

export const markerSvgHtml = (color: string) => `
  <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 384 512">
    <path fill="${color}" d="${MARKER_SVG_PATH}"/>
  </svg>
`;
